import Content from "../Projects/Content";

export default function ProjectsGridWrapper({ data, type }) {
    return <Content data={[data || []]} webGL={true} type={type} />
}
